module.exports = __webpack_public_path__ + "static/img/gradient.52506a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/gradient.jpg
// module id = fMoL
// module chunks = 1